import type { WithChildren } from '@/lib/types';

import * as S from './NavQuickLinksWithBanner.styles';

export const NavQuickLinksWithBanner = ({ children }: WithChildren) => {
  return <S.Wrapper>{children}</S.Wrapper>;
};
